import { Grid, Box } from "@mui/material"
import Link from "components/Link"
import Page from "components/Page"

const generators = [
  "cyber",
  "emblem",
  "rrrxa",
  "noise",
  "mathfont",
  "arbory",
  "ships",
  "infinethum"
]

const Generators = () => {
  return (
    <Page id="generators">
      <Grid container direction="column" alignItems="center" justifyContent="center" padding={2}>
        <Box margin={2}></Box>
        {
          generators.map((x) => {
            return <Link label={x} url={`https://generator.pxlq.art/${x}`}/> 
          })
        }
        <Box margin={20}></Box>
      </Grid>
    </Page>
  )
}

export default Generators
